/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hero_Brands_LabelInputs */

const et_hero_brands_label = /** @type {(inputs: Hero_Brands_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meie kliendid...`)
};

const en_hero_brands_label = /** @type {(inputs: Hero_Brands_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Our clients...`)
};

/**
* | output |
* | --- |
* | "Our clients..." |
*
* @param {Hero_Brands_LabelInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const hero_brands_label = /** @type {((inputs?: Hero_Brands_LabelInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hero_Brands_LabelInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_hero_brands_label(inputs)
	return en_hero_brands_label(inputs)
});